<template>
  <li>
    <router-link :to="'/equipment/timer/fresh/'+id">
      <span class="img icon-type-5"></span>
      <span class="text">定时</span>
    </router-link>
  </li>
</template>

<script>
    export default {
        name: 'eqTimer',
        props: ['eqInfo', 'id'],
    }
</script>



// WEBPACK FOOTER //
// src/components/commen/eqTimer/index.vue